import React from "react";

const PlusIcon = ({ color }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 11.4871H5V9.3071H11V2.76697H13V9.3071H19V11.4871H13V18.0273H11V11.4871Z"
      fill={color}
    />
  </svg>
);

export { PlusIcon };
